"use client"

import { RarityFilter } from "@/app/nft/search/filters/rarity-filter"
import { StatusFilter } from "@/app/nft/search/filters/status-filter"
import { TraitCounter } from "@/app/nft/search/filters/traits/counter"
import { Trans } from "@lingui/react/macro"
import {
  Button,
  InnerSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  useIsMobile,
  useSidebar,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useCallback } from "react"
import { TraitsFilter } from "../items/filters/traits/traits-filter"
import { CollectionItemPriceFilter } from "./collection-item-price-filter"

const SIDEBAR_GROUPS = [
  {
    title: <Trans>Status</Trans>,
    content: <StatusFilter />,
  },
  {
    title: <Trans>Price</Trans>,
    content: <CollectionItemPriceFilter />,
  },
  {
    title: <Trans>Rarity</Trans>,
    content: <RarityFilter />,
  },
  {
    title: (
      <div className="flex items-center gap-2">
        <Trans>Traits</Trans>
        <TraitCounter />
      </div>
    ),
    content: <TraitsFilter />,
  },
]

export const CollectionSidebar = reatomComponent(() => {
  const { toggleSidebar } = useSidebar()
  const isMobile = useIsMobile()

  const apply = useCallback(() => {
    if (isMobile) {
      toggleSidebar()
    }
  }, [isMobile, toggleSidebar])

  return (
    <InnerSidebar className="md:top-[calc(theme('spacing.header-height')+theme('spacing.collection-navigation-height'))]">
      <div className="h-full p-4 pl-6 md:p-2 md:[&&]:p-0 md:[&&]:pl-4">
        <div className="flex h-full max-h-[calc(100svh-theme('spacing.4'))] flex-col bg-background md:max-h-[calc(100svh-theme('spacing.header-height')-theme('spacing.collection-navigation-height'))]">
          <SidebarContent className="gap-6 pr-4 pl-[1px]">
            {SIDEBAR_GROUPS.map((group, idx) => (
              <SidebarGroup key={idx} className="gap-3 p-0">
                <SidebarGroupLabel className="p-0 text-lg">
                  {group.title}
                </SidebarGroupLabel>
                {group.content}
              </SidebarGroup>
            ))}
          </SidebarContent>
          <SidebarFooter className="flex-row items-center gap-4 py-4 pr-4 pl-0">
            <Button onClick={apply} className="flex-1 md:hidden">
              <Trans>Apply</Trans>
            </Button>
          </SidebarFooter>
        </div>
      </div>
    </InnerSidebar>
  )
}, "CollectionSidebar")
